import { onLCP, onFID, onCLS } from "../../../utils/web-vitals";
// import { InstanceType } from '../index'

export var startWebVitals = function startWebVitals(task) {
  startLCP(task);
  startFID(task);
  startCLS(task);
};
export var startLCP = function startLCP(task) {
  onLCP(function (metric) {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }
    console.log('[Measurements] Adding LCP');
    task === null || task === void 0 || task.setMetrics({
      type: 'lcp',
      value: parseInt(((metric === null || metric === void 0 ? void 0 : metric.value) || 0).toString(), 10)
    });
  });
};
export var startFID = function startFID(task) {
  onFID(function (metric) {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }
    console.log('[Measurements] Adding FID');
    task === null || task === void 0 || task.setMetrics({
      type: 'fid',
      value: ((metric === null || metric === void 0 ? void 0 : metric.value) || 0).toFixed(2)
    });
  });
};
export var startCLS = function startCLS(task) {
  onCLS(function (metric) {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }
    console.log('[Measurements] Adding CLS');
    task === null || task === void 0 || task.setMetrics({
      type: 'fid',
      value: ((metric === null || metric === void 0 ? void 0 : metric.value) || 0).toFixed(2)
    });
  });
};